import { useCallback, useEffect, useState } from "react";
import { Select } from "../controls";
import cities from "../utils/cities.json";

const CitiesDropdown = ({ name, value, onChange, stateId }: any) => {
  const [cats, setCats] = useState<any[]>([]);

  const reload = useCallback(() => {
    let _state: any = cities.find((k: any) => k?.abbreviation === stateId);
    let _cities: string[] = _state?.cities || [];
    let t = _cities?.map((k: string) => {
      return { label: k, value: k };
    });
    setCats(t);
  }, [stateId]);

  useEffect(() => {
    reload();
  }, [stateId, reload]);

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default CitiesDropdown;
